export default "__VITE_ASSET__MmK5Ykem__"